import { usePublicApi } from "api/setup";
import { ApiError } from "api/shared";
import formatUrl from "utils/formatUrl";

import { NoSetupIntegrations } from "components/Onboarding/hooks/useEnableNoSetUpIntegrations";
import api from "config/urls/api";

export interface EnableIntegrationBody {
  enabled: boolean;
}

export interface Integration {
  dataProvidedBy: string;
  enabled: boolean;
  integrationId: string;
  integrationType?: string;
  isBeta: boolean;
  key: string;
  name: NoSetupIntegrations;
  supportedEnvironments: string;
  logoUrl: string;
  sourceId: string;
  isOfflineConnector: boolean;
  linkedConnectionsCount: number;
  totalConnectionsCount: number;
  sourceType?: string;
}

export const useToggleIntegrationMutation = (platformKey: string) =>
  usePublicApi<Integration, ApiError>(
    {
      url: formatUrl(api.integrations.enabled, { platformKey }),
      method: "PUT",
    },
    { manual: true }
  );
